import axiosRetry from 'axios-retry';
import axios from 'axios';

// Configure axios-retry
export const retryFailedApi = () =>
  axiosRetry(axios, {
    retries: 3, // Number of retries
    retryCondition: () => true, // Retry all errors
  });
